import { Box } from "@mui/material"

const OneDivider = ({ sx }) => {
    return (
        <Box sx={{ ...sx, width: '100%', height: '1px', backgroundColor: '#00000024' }}></Box>
    )
}

export default OneDivider
